class Storage {
  subscriptions: Map<string, number>;
  name: string;
  queue: string[];
  constructor(name: string) {
    this.name = name;
    this.subscriptions = new Map<string, number>();
    this.queue = [];
  }

  addToQueue(code: string) {
    this.queue.push(code);
  }

  getQueue() {
    return this.queue;
  }

  add(code: string) {
    const count = this.getSubscriptionsCount(code);
    this.subscriptions.set(code, count + 1);
  }

  remove(code: string) {
    const count = this.getSubscriptionsCount(code);
    this.subscriptions.set(code, count - 1);
  }

  isLast(code: string) {
    const count = this.getSubscriptionsCount(code);
    return count === 1;
  }

  isExist(code: string) {
    const count = this.getSubscriptionsCount(code);
    return !!count;
  }

  getSubscriptionsCount(code: string) {
    return this.subscriptions.get(code) || 0;
  }
}

export default Storage;
